<template>
    <el-container direction="vertical" class="spreadsheet">
        <el-row type="flex" align="middle" class="spreadsheet-header" justify="space-between">
            <el-col :span="13">
                <el-row>
                    <el-col>
                        <expense-regular-edit-popup
                            :is-visible="isExpenseVisible"
                            :expense-id="expenseId"
                            @changeVisibility="changeVisibility"
                            @getDataFromServer="getDataFromServer"
                        />
                    </el-col>
                    <el-col>
                        <div class="spreadsheet-header-title">
                            {{ title }}
                        </div>
                        <div class="spreadsheet-header-filter-info">
                            <span class="spreadsheet-header-filter-info_black">
                                Поиск по:
                            </span>
                            <span class="spreadsheet-header-filter-info_gray">
                                {{ filterTitle }}
                            </span>
                        </div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col>
                        <span class="spreadsheet-header-filter-info_black">
                            Всего найдено:
                        </span>
                        <span class="spreadsheet-header-filter-info_gray">
                            {{ pagesInfo.total }} расходов на сумму {{ pagesInfo.totalAmount }} р.
                        </span>
                    </el-col>
                </el-row>
            </el-col>
            <el-col :span="2">
                <el-popover
                    popper-class="grid-search-dialog"
                    placement="top"
                    width="293"
                    trigger="click"
                    v-model="isFilterFormVisible"
                >
                    <el-button slot="reference" class="spreadsheet-header-button" type="warning">
                        поиск
                    </el-button>
                    <el-form label-position="top" @keyup.enter.native="filterApplied">
                        <el-form-item :label="fieldsNames.id" :label-width="formLabelWidth" v-if="isColumnVisible('id')">
                            <el-input v-model="filterModel.id" autocomplete="off" size="mini" clearable />
                        </el-form-item>
                        <el-form-item :label="fieldsNames.created_at" :label-width="formLabelWidth" v-if="isColumnVisible('created_at')">
                            <el-date-picker
                                v-model="filterModel.created_at"
                                type="daterange"
                                range-separator="по"
                                start-placeholder="дата"
                                end-placeholder="дата"
                                clearable
                                format="dd.MM.yyyy"
                                value-format="dd.MM.yyyy"
                                :picker-options="pickerOptions"
                                size="mini"
                                class="w100"
                            />
                        </el-form-item>
                        <el-form-item :label="fieldsNames.creator_full_name" :label-width="formLabelWidth" v-if="isColumnVisible('created_by.full_name')">
                            <el-select
                                v-model="filterModel.creator_full_name"
                                placement="bottom"
                                popper-class="popper-dropdown"
                                multiple
                                collapse-tags
                                clearable
                                :placeholder="fieldsNames.creator_full_name"
                                size="mini"
                            >
                                <el-option v-for="item in employersList" :key="item.id" :label="item.name" :value="item.id" />
                            </el-select>
                        </el-form-item>
                        <el-form-item :label="fieldsNames.recipient_id" :label-width="formLabelWidth" v-if="isColumnVisible('recipient_id')">
                            <el-select
                                v-model="filterModel.recipient_id"
                                placement="bottom"
                                popper-class="popper-dropdown"
                                filterable
                                collapse-tags
                                clearable
                                autocomplete
                                multiple
                                :placeholder="fieldsNames.recipient_id"
                                size="mini"
                            >
                                <el-option v-for="item in receivedByIdListForFilter" :key="item.id" :label="item.name" :value="item.id" />
                            </el-select>
                        </el-form-item>
                        <el-form-item :label="fieldsNames.cash" :label-width="formLabelWidth" v-if="isColumnVisible('cash')">
                            <el-select
                                v-model="filterModel.cash"
                                placement="bottom"
                                popper-class="popper-dropdown"
                                filterable
                                multiple
                                collapse-tags
                                clearable
                                autocomplete
                                :placeholder="fieldsNames.cash"
                                size="mini"
                            >
                                <el-option v-for="item in cashList" :key="item.id" :label="item.name" :value="item.id" />
                            </el-select>
                        </el-form-item>
                        <el-form-item :label="fieldsNames.period" :label-width="formLabelWidth" v-if="false">
                            <el-date-picker
                                v-model="filterModel.period"
                                type="daterange"
                                range-separator="по"
                                start-placeholder="дата"
                                end-placeholder="дата"
                                clearable
                                format="dd.MM.yyyy"
                                value-format="dd.MM.yyyy"
                                :picker-options="pickerOptions"
                                size="mini"
                                class="w100"
                            />
                        </el-form-item>
                        <el-form-item :label="fieldsNames.date" :label-width="formLabelWidth" v-if="isColumnVisible('date')">
                            <el-date-picker
                                v-model="filterModel.date"
                                type="daterange"
                                range-separator="по"
                                start-placeholder="дата"
                                end-placeholder="дата"
                                clearable
                                format="dd.MM.yyyy"
                                value-format="dd.MM.yyyy"
                                :picker-options="pickerOptions"
                                size="mini"
                                class="w100"
                            />
                        </el-form-item>
                        <el-form-item :label="fieldsNames.amount" :label-width="formLabelWidth" v-if="isColumnVisible('amount')">
                            <el-input v-model="filterModel.amount" autocomplete="off" size="mini" clearable />
                        </el-form-item>
                    </el-form>
                    <div class="popover-footer">
                        <el-button @click="hideFilterForm">
                            Отменить
                        </el-button>
                        <el-button type="warning" @click="filterApplied">
                            Применить
                        </el-button>
                    </div>
                </el-popover>
            </el-col>
            <el-col :span="3">
                <span class="spreadsheet-header-total">
                    Всего записей: {{ pagesInfo.total }}
                </span>
            </el-col>
            <el-col :span="3">
                <el-button
                    id="create-expense-regular"
                    class="spreadsheet-header-button"
                    type="warning"
                    @click="goNewExpense"
                    v-if="headerOptions.isNewButtonVisible && canCreateExpense"
                >
                    <span class="create-expense-regular-title">
                        новый расход
                    </span>
                </el-button>
            </el-col>
            <el-col :span="1" title="Excel" class="icon-excel" v-if="isExcelButtonVisible">
                <div class="spreadsheet-header-excel">
                    &nbsp;
                </div>
            </el-col>
        </el-row>
        <el-row type="flex" align="top" class="spreadsheet-table" v-loading="loading">
            <el-col :span="24">
                <ag-grid-vue
                    class="ag-theme-balham spreadsheet-table-grid"
                    :grid-options="gridOptions"
                    :column-defs="columnDefs"
                />
            </el-col>
        </el-row>
        <el-row type="flex" align="bottom" class="spreadsheet-bar">
            <el-col :span="6">
                <el-pagination
                    background
                    layout="prev, pager, next"
                    :total="pagesInfo.total"
                    :page-size="pageModel.pageSize"
                    :current-page="pageModel.currentPage"
                    :small="true"
                    @current-change="getCurrentPage"
                />
            </el-col>
            <el-col :span="10">
                <div class="spreadsheet-bar-pages">
                    <span class="spreadsheet-bar-pages-title">
                        Выводить по:
                    </span>
                    <span
                        class="spreadsheet-bar-pages-size"
                        :class="{'is-active': isSetPageSize20}"
                        @click="setPageSize(20)"
                    >
                        20
                    </span>
                    <span
                        class="spreadsheet-bar-pages-size"
                        :class="{'is-active': isSetPageSize50}"
                        @click="setPageSize(50)"
                    >
                        50
                    </span>
                    <span
                        class="spreadsheet-bar-pages-size"
                        :class="{'is-active': isSetPageSize100}"
                        @click="setPageSize(100)"
                    >
                        100
                    </span>
                </div>
            </el-col>
            <el-col :span="8">
                <div class="spreadsheet-bar-total">
                    <span>
                        Строк выведено: {{ totalRows }} Из них выделено: {{ selectedRowsCount }}
                    </span>
                </div>
            </el-col>
        </el-row>
    </el-container>
</template>

<script>
import ExpenseMixin from '@/mixins/expense';
import ExpenseRegularEditPopup from '@/components/expenses/ExpenseRegularEditPopup';
import { AgGridVue } from 'ag-grid-vue';
import TableHeaderSettings from '@/components/TableHeaderSettings';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faEye } from '@fortawesome/free-solid-svg-icons';
import capitalize from 'lodash/capitalize';
import '@/assets/styles/list.scss';
import localReferences from '@/helpers/localReferences';

library.add(faEye);

export default {
    name: 'ExpenseRegularBaseGrid',
    mixins: [
        ExpenseMixin
    ],
    data() {
        return {
            title: 'Авансы',
            pageName: 'expenses-prepayments',
            isExpenseVisible: false,
            expenseId: null,
            isFilterFormVisible: false,
            headerOptions: {
                isNewButtonVisible: true
            },
            settingName: 'expenses-prepayments',
            isPayTypeFilterVisible: true,
            filterModel: {
                id: null,
                created_at: [],
                creator_full_name: [],
                expense_type: [],
                recipient_type: localReferences.expenseRecipient.employer,
                recipient_id: [],
                cash: [],
                //period: [],
                date: [],
                amount: null
            },
            fieldsNames: {
                id: 'id',
                created_at: 'дата создания',
                creator_full_name: 'создатель',
                expense_type: 'статья',
                recipient_type: 'получил - тип',
                recipient_id: 'получил',
                cash: 'касса',
                //period: 'отчётный период',
                date: 'дата расхода',
                amount: 'сумма'
            },
            pageModel: {
                currentPage: 1,
                pageSize: 20
            },
            formLabelWidth: '120px',
            totalRows: 0,
            selectedRowsCount: 0,
            loading: true,
            gridOptions: {
                rowSelection: 'multiple',
                suppressDragLeaveHidesColumns: false,
                suppressPaginationPanel: true,
                suppressLoadingOverlay: true,
                rowDeselection: true,
                enableCellTextSelection: true,
                headerHeight: 50,
                rowHeight: 40,
                domLayout: 'autoHeight',
                onRowDataChanged: this.onRowDataChanged.bind(this),
                onRowSelected: this.onRowSelected.bind(this),
                onColumnResized: this.onColumnResized.bind(this),
                onDisplayedColumnsChanged: this.onDisplayedColumnsChanged.bind(this),
                onRowDoubleClicked: this.onSelectionChanged.bind(this),
                onSortChanged: this.onSortChanged.bind(this),
                defaultColDef: {
                    sortable: true,
                    filter: false,
                    resizable: true,
                    cellClass: 'column-text',
                    comparator: () => {
                        return 0;
                    }
                }
            },
            columnDefs: [],
            cashPayTypes: [],
            cashlessPayTypes: [],
            isCashLess: false
        };
    },
    components: {
        AgGridVue,
        ExpenseRegularEditPopup
    },
    computed: {
        expenses() {
            return this.$store.state.expenses.expenses;
        },
        pagesInfo() {
            return this.$store.state.expenses.pages;
        },
        setting() {
            return this.$store.state.preferences.setting;
        },
        isSetPageSize20() {
            return this.pageModel.pageSize === 20;
        },
        isSetPageSize50() {
            return this.pageModel.pageSize === 50;
        },
        isSetPageSize100() {
            return this.pageModel.pageSize === 100;
        },
        filterTitle() {
            let result = '';
            for (const field in this.filterModel) {
                if (Object.prototype.hasOwnProperty.call(this.filterModel, field) && this.filterModel[field]) {
                    if (['string', 'object'].includes(typeof this.filterModel[field]) && this.filterModel[field].length) {
                        switch (field) {
                            case 'creator_full_name':
                                result += this.getNames(this.employersList, field);
                                break;
                            case 'created_at':
                                result += `${this.fieldsNames[field]}: c ${this.filterModel[field][0]}
                             по ${this.filterModel[field][1]}; `;
                                break;
                            case 'expense_type':
                                result += this.getNames(this.expenseTypeList, field);
                                break;
                            case 'recipient_type':
                                result += this.getOneName(this.receivedFromTypesList, field);
                                break;
                            case 'recipient_id':
                                result += this.getNames(this.receivedByIdListForFilter, field);
                                break;
                            case 'cash':
                                result += this.getNames(this.cashList, field);
                                break;
                            default:
                                result += `${this.fieldsNames[field]}: ${this.filterModel[field]}; `;
                        }
                    }
                }
            }
            return result;
        },
        isExcelButtonVisible() {
            //использовать в задаче реализации экспорта в excel
            return false;
        },
        canCreateExpense() {
            return this.$store.getters.isExpensesAll;
        }
    },
    created() {
        this.cashPayTypes = this.localReferences.payTypesCash;
        this.cashlessPayTypes = this.localReferences.payTypesCashless;
        this.columnDefs = [
            {
                headerName: this.capitalize(this.fieldsNames.id),
                field: 'id'
            },
            {
                headerName: this.capitalize(this.fieldsNames.created_at),
                field: 'created_at'
            },
            {
                headerName: this.capitalize(this.fieldsNames.creator_full_name),
                field: 'created_by.full_name'
            },
            {
                headerName: this.capitalize(this.fieldsNames.expense_type),
                field: 'expense_type',
                sortable: false,
                cellRenderer: ({ data }) => data.details ? this.getName(this.expenseTypeList, data.details.filter(item => item.expense_type !== null).map(item => item.expense_type)) : ''
            },
            {
                headerName: this.capitalize(this.fieldsNames.recipient_type),
                field: 'recipient_type',
                cellRenderer: ({ data }) => this.getName(this.receivedFromTypesList, data.recipient_type)
            },
            {
                headerName: this.capitalize(this.fieldsNames.recipient_id),
                field: 'recipient_id',
                cellRenderer: ({ data }) => data.recipient.name
            },
            {
                headerName: this.capitalize(this.fieldsNames.cash),
                field: 'cash',
                cellRenderer: ({ data }) => data.source_type === this.localReferences.expenseSource.cash ? data.source.name : ''
            },
            {
                headerName: this.capitalize(this.fieldsNames.date),
                field: 'date'
            },
            {
                headerName: this.capitalize(this.fieldsNames.amount),
                field: 'amount'
            },
            {
                headerName: '',
                field: '',
                headerComponentFramework: TableHeaderSettings,
                cellRenderer: ({ data }) => {
                    return this.getLinkElement(data.id, '', this.getRouteForCard(data), 'div', 'cell-icon');
                },
                width: 40,
                cellClass: null
            }
        ];
    },
    mounted() {
        this.loadSettings();
        this.$store.commit('expenses/setCurrentPage', this.pageName);
    },
    methods: {
        loadSettings: function() {
            this.$store.dispatch('preferences/getPreferences').then(
                () => {
                    this.setSettings();
                }).catch(() => {
                this.getDataFromServer();
            });
            //this.getDataFromServer();
        },
        setSettings() {
            const settings = this.setting[this.settingName];
            if (settings) {
                this.gridOptions.columnApi.setColumnState(settings.table);
                this.gridOptions.api.setSortModel({});
                this.filterModel = JSON.parse(JSON.stringify(settings.filter));
                this.pageModel = JSON.parse(JSON.stringify(settings.page));
            } else {
                this.gridOptions.api.setSortModel({});
            }
        },
        hideFilterForm() {
            this.isFilterFormVisible = false;
        },
        getLinkElement(id, name, route, elementType, className) {
            const element = document.createElement(elementType);
            if (elementType === 'a') {
                element.href = this.$router.resolve(route).href;
            }
            element.innerText = name;
            element.className += ' ' + className;
            element.addEventListener('click', e => {
                e.preventDefault();
                this.$router.push(route);
            });
            return element;
        },
        edit() {
            this.$router.push({ name: 'expense-edit', params: { id: '' + this.id } });
        },
        getRouteForCard(data) {
            const params = { id: '' + data.id };
            return { name: 'expense-edit', params };
        },
        onSelectionChanged(e) {
            this.showExpense(e.node.data.id);
        },
        getDataFromServer() {
            const requestParams = {
                size: this.pageModel.pageSize,
                page: this.pageModel.currentPage,
                sort: this.gridOptions.api.getSortModel(),
                filter: this.filterModel,
                pageName: this.pageName
            };
            this.loading = true;
            this.$store.dispatch('expenses/getPaginatedList', requestParams).then(
                response => {
                    this.gridOptions.api.setRowData(this.expenses);
                    this.pageModel.pageSize = +response.data.meta.per_page;
                    this.pageModel.currentPage = response.data.meta.current_page;
                    this.saveSetting();
                }).finally(() => {
                this.loading = false;
            });
        },
        async getExpense() {
            this.loadingMain = true;
            try {
                this.expense = await this.$store.dispatch('expenses/getExpense', this.id);
            } catch (error) {
                console.log(error);
            } finally {
                this.loadingMain = false;
            }
        },
        setPageSize(size) {
            this.pageModel.pageSize = size;
            this.getDataFromServer();
        },
        showExpense(expenseId = -1) {
            this.isExpenseVisible = !this.isExpenseVisible;
            this.expenseId = expenseId;
        },
        changeVisibility() {
            this.$emit('changeVisibility', false);
            this.isExpenseVisible = !this.isExpenseVisible;
            this.expenseId = null;
        },
        goNewExpense() {
            this.showExpense();
        },
        getCurrentPage(page) {
            this.pageModel.currentPage = page;
            this.getDataFromServer();
        },
        filterApplied() {
            this.isFilterFormVisible = false;
            this.pageModel.currentPage = 1;
            this.getDataFromServer();
        },
        onRowDataChanged() {
            this.totalRows = this.gridOptions.api.getDisplayedRowCount();
        },
        onRowSelected() {
            this.selectedRowsCount = this.gridOptions.api.getSelectedRows().length;
        },
        isColumnVisible(colId) {
            return this.isFilterFormVisible && this.gridOptions.columnApi ? this.gridOptions.columnApi.getColumn(colId).visible : false;
        },
        onDisplayedColumnsChanged() {
            this.saveSetting();
        },
        onColumnResized(data) {
            if (data.finished && data.source === 'uiColumnDragged') {
                this.saveSetting();
            }
        },
        onSortChanged() {
            this.getDataFromServer();
        },
        async saveSetting() {
            const data = {};
            data[this.settingName] = {
                'table': this.gridOptions.columnApi.getColumnState(),
                'sort': this.gridOptions.api.getSortModel(),
                'filter': this.filterModel,
                'page': this.pageModel
            };
            await this.$store.dispatch('preferences/setPreferences', data);
        },
        capitalize,
        getNames(obj, field) {
            if (Object.keys(obj).length !== 0) {
                return `${this.fieldsNames[field]}: ${this.filterModel[field].map(id => obj.find(item => item.id === id).name).join(' | ')}; `;
            }
            return '';
        },
        getOneName(obj, field) {
            if (Object.keys(obj).length !== 0) {
                return `${this.fieldsNames[field]}: ${obj.filter(item => item.id === this.filterModel[field]).map(item => item.name).join('')}; `;
            }
            return '';
        }
    }
};
</script>
